import { css } from '@emotion/react'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useLayoutEffect } from 'react'
import { Provider } from 'react-redux'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from '@/components/atoms/Breadcrumb'
import { SearchCompaniesHead } from '@/components/common/Head'
import { Template } from '@/components/common/Template'
import { EnterpriseGuideTemplate } from '@/components/view/EnterpriseGuide'
import { useUser } from '../../contexts/AuthContext'
import { isEnterprise, isTrial } from '@/lib/user'
import SearchCondition from '@/components/pages/companies/containers/search-condition'
import SearchResult from '@/components/pages/companies/containers/search-result'
import configureStore from '@/components/pages/companies/stores'

const store = configureStore()

const CompaniesPage: NextPage = () => {
  const user = useUser()
  const router = useRouter()

  useLayoutEffect(() => {
    const searchCondition: { url: string; y_offset: string } | null =
      JSON.parse(sessionStorage.getItem('search_condition')!)
    if (searchCondition && window.location.href !== searchCondition.url) {
      router.push(searchCondition.url)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isEnterprise(user) || isTrial(user) ? (
    <>
      <Provider store={store}>
        <Template>
          <SearchCompaniesHead />
          <div
            className="plume companies-page"
            data-test-id="companies-page"
            css={css`
              overflow-x: hidden;
            `}
          >
            <div
              className="search-condition"
              css={css`
                margin: 10px 24px 20px;
              `}
            >
              <Breadcrumb
                css={css`
                  margin-bottom: 12px;
                `}
              >
                <BreadcrumbLink href="/" passHref>
                  ホーム
                </BreadcrumbLink>
                <BreadcrumbItem className="in-breadcrumb-item">
                  スタートアップ
                </BreadcrumbItem>
              </Breadcrumb>
              <SearchCondition />
            </div>
            <div className="search-result">
              <SearchResult />
            </div>
          </div>
        </Template>
      </Provider>
    </>
  ) : (
    <EnterpriseGuideTemplate />
  )
}

export default CompaniesPage
